export default __webpack_public_path__ + "static/media/template12.74886171.svg";